/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.partner.client.ai.rpc.PartnerClientAiSummaryRpc
 */

export const getSummaryRpc = {
  serviceName: 'com.hubspot.partner.client.ai.rpc.PartnerClientAiSummaryRpc',
  rpcName: 'getSummary',
  auth: 'app',
  fingerprint: 'uGv9FDMnWyT3iHtQQbuFEWHFz3qW4UeU',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getLocalTestSummaryRpc = {
  serviceName: 'com.hubspot.partner.client.ai.rpc.PartnerClientAiSummaryRpc',
  rpcName: 'getLocalTestSummary',
  auth: 'app',
  fingerprint: 'uGv9FDMnWyT3iHtQQbuFEWHFz3qW4UeU',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};